import { Capacitor } from "@capacitor/core";
import { initializeApp } from "firebase/app";
import {
  connectAuthEmulator,
  getAuth,
  indexedDBLocalPersistence,
  initializeAuth,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDk4r3UA3fMOd4zSTIxraTmRZdZJ7ICbUs",
  authDomain: "recipes-496701.firebaseapp.com",
  projectId: "recipes-496701",
  storageBucket: "recipes-496701.firebasestorage.app",
  messagingSenderId: "151018575958",
  appId: "1:151018575958:web:5b1c87caa5b1dacdf383f7",
};

export const app = initializeApp(firebaseConfig);
// In the Capacitor WKWebView the origin is capacitor://localhost, where
// getAuth()'s popup/redirect resolver stalls during init and auth never
// reports a state (the app hangs on its loading screen). initializeAuth with
// explicit persistence and no resolver is Firebase's documented setup for
// Capacitor; popup/redirect sign-in is unavailable on native either way.
export const auth = Capacitor.isNativePlatform()
  ? initializeAuth(app, { persistence: indexedDBLocalPersistence })
  : getAuth(app);
export const db = getFirestore(app);

// Local emulator wiring — only when explicitly opted in via VITE_USE_EMULATOR=1.
// Playwright (and any future vitest setup) sets this. Production builds skip it.
if (import.meta.env.VITE_USE_EMULATOR === "1") {
  const authHost = import.meta.env.VITE_AUTH_EMULATOR_URL ?? "http://127.0.0.1:9099";
  const fsHost = import.meta.env.VITE_FIRESTORE_EMULATOR_HOST ?? "127.0.0.1:8080";
  const [fsHostname, fsPort] = fsHost.split(":");
  connectAuthEmulator(auth, authHost, { disableWarnings: true });
  connectFirestoreEmulator(db, fsHostname, Number(fsPort));

  // Test affordance: expose a sign-in helper so Playwright can authenticate
  // via page.evaluate() without resolving bare-module specifiers. Gated by
  // VITE_USE_EMULATOR so it never ships in production builds.
  (window as unknown as {
    __TEST_SIGN_IN__?: (email: string, password: string) => Promise<void>;
  }).__TEST_SIGN_IN__ = async (email, password) => {
    await signInWithEmailAndPassword(auth, email, password);
  };
}
